import angular, { IExceptionHandlerService } from 'angular';
import { crl8 } from 'app/curalate.globals';

/**
 * Register override behavior for the default $exceptionHandler on
 * the curalate.app module. This will send all errors to logging services.
 */
angular.module('curalate').config([
  '$provide',
  ($provide: angular.auto.IProvideService) => {
    $provide.decorator('$exceptionHandler', [
      '$delegate',
      ($delegate: IExceptionHandlerService) => {
        return (exception: Error, cause?: string) => {
          if (crl8.logger.isInitialized()) {
            crl8.logger.cloud.captureException(exception);
          }
          $delegate(exception, cause);
        };
      },
    ]);
  },
]);
